enum LoginType {
  ADMIN = 1,
  PARENT = 2,
  STUDENT = 3,
  TEACHER = 4
}

enum QuestionType {
  MCQ = 1,
  Checkbox = 2,
  Text = 3,
  MultipleText = 4
}

enum ImageStatus {
  Skip = 1,
  Update = 2,
  Delete = 3
}

enum ExamType {
  Review = 1,
  Practice_Session = 2
}

enum AssigningActivityType {
  ENRICHMENT = 1,
  REMEDIAL = 2
}

enum FileType {
  Audio = 1,
  Video = 2,
  Document = 3,
  Image = 4,
  Link = 5
}

enum ParentDashboardType {
  MY_STUDENTS = 1,
  STUDENT_RECORDS = 2
}

enum ModuleMenu {
  M_INTRO = 1,
  M_Practice_Session = 2,
  M_LEARNING = 3,
  M_REVIEW = 4,
  M_HOMEWORK = 5,
  M_HELP = 6
}

enum ForgotPasswordScreenType {
  EmailInput = 1,
  Verify = 2,
  NewPassword = 3
}

enum ActivityNavigation {
  Activity = 0,
  Learning = 1,
  Review = 2,
  Homework = 3,
  AskHelp = 4,
  PracticeSession = 5
}

enum StudentActionsForParent {
  View = 0,
  Edit = 1
}

enum AssessmentScreenType {
  Intro = 1,
  Details = 2,
  AttendExam = 3,
  Results = 4
}

enum ExamScreenType {
  Intro = 1,
  AttendExam = 2,
  Results = 3
}

enum ActivityExamScreenType {
  VIEW = 0,
  QA = 1
}

enum AskForHelpScreenType {
  Intro = 1,
  Waiting = 2,
  Meeting = 3
}

enum ViewEdit {
  VIEW = 1,
  EDIT = 2
}

export {
  LoginType,
  QuestionType,
  ImageStatus,
  ExamType,
  AssigningActivityType,
  FileType,
  ParentDashboardType,
  ActivityNavigation,
  ForgotPasswordScreenType,
  ModuleMenu,
  StudentActionsForParent,
  AssessmentScreenType,
  ExamScreenType,
  ActivityExamScreenType,
  AskForHelpScreenType,
  ViewEdit
};
